
import { InvItem, Recipes } from "@/models/GameType";
import { toArray } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import RecipeBoxAdd from "./RecipeBoxAdd.vue";

@Component({
  components: { RecipeBoxAdd },
})
class RecipeBox extends Vue {
  @Prop({ default: null }) readonly recipe!: Recipes;
  @Prop({ default: null }) readonly arrayIndex!: number;
  @Prop({ default: null }) readonly invData!: InvItem[];
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: null }) readonly currentInv!: string;
  openAdd = false;
  recipeArray: any[] = [];
  deleteItem = false;
  tempRecipe = {} as any;

  get getRecipesItemArray(): any {
    return this.recipeArray;
  }

  created(): void {
    this.recipeArray = toArray(this.recipe.items);
  }
  cancel(): void {
    this.openAdd = false;
  }
  close(): void {
    this.$bvModal.hide("team-modal-sure");
  }
  openDialog(value: boolean, recipe: any): void {
    if (!this.isEditingLocked) {
      this.deleteItem = value;
      this.tempRecipe = recipe;
      this.$bvModal.show("team-modal-sure");
    }
  }
  openAddBox(): void {
    if (!this.isEditingLocked) {
      this.openAdd = true;
    }
  }
  updateQuantiy(value: any): void {
    this.recipe.items[value.slug] = {
      quant: value.quant,
      name: { en: value.name },
      slug: value.slug,
    };
    this.$emit("addAdditionalItems", {
      items: this.recipe.items,
      index: this.arrayIndex,
    });
  }
  receipeData(value: any): void {
    this.recipe.items[value.slug] = {
      quant: value.quantity,
      name: { en: value.item },
      slug: value.slug,
    };
    this.recipeArray = toArray(this.recipe.items);
    this.$emit("addAdditionalItems", {
      items: this.recipe.items,
      index: this.arrayIndex,
    });
    this.openAdd = false;
  }
  removeItemFromArray(): void {
    if (this.recipeArray.length == 1 || this.deleteItem) {
      this.$emit("deleteRecipe", this.arrayIndex);
      this.$bvModal.hide("team-modal-sure");
    } else {
      var deleteIndex = this.recipeArray.findIndex(
        (x: any) => x === this.tempRecipe
      );
      this.recipeArray.splice(deleteIndex, 1);
      delete this.recipe.items[this.tempRecipe.slug];
      this.recipeArray = toArray(this.recipe.items);
      var data = { items: this.recipe.items, index: this.arrayIndex };
      this.$emit("deleteRecipeItem", data);
      this.$bvModal.hide("team-modal-sure");
    }
  }
  @Watch("recipe")
  getRecipeData(value: Recipes): void {
    this.recipeArray = toArray(value.items);
  }
}

export default RecipeBox;
